export const roundNumberToTwoPrecision = (value: number) => {
  return Math.round(value * 100) / 100;
};

export const formatNum = (n: any, min = 0, max = 2) => {
  if (n === undefined || n === null || n === '') return '';

  const str = String(n)
    .trim()
    .replace(/[\u00A0\s]/g, '')
    .replace(',', '.');
  const num = Number(str);
  if (!Number.isFinite(num)) return '';

  const parts = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: min,
    maximumFractionDigits: max,
    useGrouping: true,
  }).formatToParts(n);

  return parts
    .map(p => (p.type === 'group' ? '\u00A0' : p.type === 'decimal' ? '.' : p.value))
    .join('');
};
